// extracted by mini-css-extract-plugin
export default {"save_money_content":"index_save_money_content__EOooe","save_money":"index_save_money__WCGxD","add":"index_add__a1AD3"};